/**
 * 車輌外装キズModal
 */

/* Import Modules */
import { ref } from "vue";
import $ from "jquery";

/* Import Variables */
import { rentalContractEditForm } from "../../variables";

/* Define Variables */
export const exteriorCheckModalRef = ref<any>(null);
export const exteriorCheckRow = 12; // 行数
export const exteriorCheckCol = 8; // 列数

/* Define Functions */
export const showExteriorCheckModal = () => {
  exteriorCheckModalRef.value?.showModal();
};

const hideExteriorCheckModal = () => {
  exteriorCheckModalRef.value?.hideModal();
};

/**
 * キズ情報更新
 * @param row
 * @param col
 */
export const setExteriorCheck = (row: number, col: number) => {
  // 反映対象のノードIDを取得
  let elementId = "#exterior_modal_" + row + "_" + col;
  // 更新内容 反映
  $(elementId).text($("input[name='exterior-radio']:checked").val());
};

/**
 * 車輌外装キズ情報 保存処理
 */
export const setExteriorData = () => {
  let checkValue = "";
  for (let m = 1; m <= exteriorCheckRow; m++) {
    for (let n = 1; n <= exteriorCheckCol; n++) {
      /* ElementIdを取得 */
      let elementId = "#exterior_" + m + "_" + n;
      let elementModalId = "#exterior_modal_" + m + "_" + n;

      /* カンマベースの入力値を取得 */
      checkValue += $(elementModalId).text();
      checkValue += ",";

      /* キズ情報 コピー処理 */
      $(elementId).text($(elementModalId).text());
    }
  }
  checkValue = checkValue.slice(0, -1);
  /* Move Exterior Value */
  $("#exteriorCheck").val(checkValue);
  rentalContractEditForm.exteriorCheck = checkValue;
  hideExteriorCheckModal();
};

/**
 * 車輌外装キズ情報 表示処理
 * @param exteriorCheck
 */
export const setExteriorDataByRentalContractModal = (exteriorCheck: string) => {
  /* expload params by separator = "," */
  const exteriorPart = exteriorCheck.split(",");
  let index = 0;
  for (let i = 1; i <= exteriorCheckRow; i++) {
    for (let j = 1; j <= exteriorCheckCol; j++) {
      /* Define Variables. */
      let elementId = "#exterior_" + i + "_" + j;
      let elementModalId = "#exterior_modal_" + i + "_" + j;

      /* Move Exterior Value */
      $(elementId).text(exteriorPart[index]);
      $(elementModalId).text(exteriorPart[index]);

      ++index;
    }
  }
};
